<template>
  <div v-if="learningArea" class="learning-area-label">
    <component
      :is="badgeIcon"
      v-if="showIcon"
      :class="[
        'learning-area-label__icon',
        extraSmallMobile && 'learning-area-label__icon--mobile',
      ]"
    />
    <div
      v-if="showText"
      :class="[
        'learning-area-label__text',
        uppercase && 'learning-area-label__text--uppercase',
        extraSmallMobile && 'learning-area-label__text--extra-small',
      ]"
    >
      {{ learningArea }}
    </div>
  </div>
</template>

<script>
import CyberSecurity from '@/assets/images/learning-areas/noborders/cybersecurity.svg'
import Networking from '@/assets/images/learning-areas/noborders/networking.svg'
import Cloud from '@/assets/images/learning-areas/noborders/cloud.svg'
import CONSTANTS from '@/constants'

export default {
  name: 'LearningAreaLabel',
  components: {
    CloudIcon: { ...Cloud, name: 'CloudIcon' },
    CyberSecurityIcon: { ...CyberSecurity, name: 'CyberSecurityIcon' },
    NetworkingIcon: { ...Networking, name: 'NetworkingIcon' },
  },
  props: {
    learningArea: {
      type: String,
      required: true,
    },
    showIcon: {
      type: Boolean,
      required: false,
      default: true,
    },
    showText: {
      type: Boolean,
      required: false,
      default: true,
    },
    uppercase: {
      type: Boolean,
      required: false,
      default: false,
    },
    extraSmallMobile: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  computed: {
    badgeIcon() {
      const {
        LEARNING_AREAS: { PRIMARY },
      } = CONSTANTS
      let badge = ''
      switch (this.learningArea) {
        case PRIMARY['Cyber Security'].id:
        case PRIMARY['Cyber Security'].name:
        case PRIMARY['Cyber Security'].slug:
          badge = 'CyberSecurityIcon'
          break
        case PRIMARY.Cloud.id:
        case PRIMARY.Cloud.name:
        case PRIMARY.Cloud.slug:
          badge = 'CloudIcon'
          break
        case PRIMARY.Networking.id:
        case PRIMARY.Networking.name:
        case PRIMARY.Networking.slug:
          badge = 'NetworkingIcon'
          break
      }
      return badge
    },
  },
}
</script>

<style lang="scss" scoped>
.learning-area-label {
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  &__icon {
    margin-right: 5px;
    &--mobile {
      display: none;

      @include mobile {
        display: inherit;
      }
    }
  }
  &__text {
    color: var(--white);
    font-size: rem(12px);
    font-style: normal;
    font-weight: 450;
    line-height: rem(14px);
    &--uppercase {
      text-transform: uppercase;
    }
    &--extra-small {
      font-size: rem(10px);
      line-height: rem(12px);

      @include mobile {
        font-size: rem(12px);
        line-height: rem(14px);
      }
    }
  }
}
</style>
